<template>
    <div class="enter-cabinet normalize">
        <enter-cabinet-header />

        <!--     выбор авторизации через телефон или почту   -->
        <enter-cabinet-choose v-if="activeTab === 'enter'" />


        <!--        Форма регистрации - phone-->
        <registration-phone v-if="activeTab === 'registration' && chooseEnter === 'phone'" />

        <!--        Форма регистрации - email-->
        <registration-email v-if="activeTab === 'registration' && chooseEnter === 'email'" />


        <div v-if="activeTab === 'enter'" class="enter-cabinet__tab">
            <!--            Форма авторизации - email-->
            <authentication-email v-if="chooseEnter === 'email'" />
            <!--            Форма авторизации с телефона-->
            <authentication-phone v-else />
        </div>
        <!--Вывод ошибок-->
        <enter-cabiner-errors />
        <!--Кнопка смены окна между регистрацией и входом-->
        <enter-cabinet-nav />



        <div v-if="this.count > 0 && activeTab === 'registration'" class="register_resend_message">
            <span>{{authData.messages.phone_code_timer + count +' сек'}}</span>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
    export default {
        name: 'enter-cabinet',
        selector: '.enter-cabinet',
        data() {
            return {
                count: '',
            }
        },
        computed: {
            ...mapState({
                authData: ({ personal }) => personal.data,
                activeTab: ({ personal }) => personal.data.activeTab,
                chooseEnter: ({ personal }) => personal.data.chooseEnter,
                errors: ({ personal }) => personal.data.errors,
            }),
        },
        methods: {
            ...mapMutations({
                clearState: 'personal/clearState',
            }),

            async getRegData() {
                const {path, data: {action, LANGUAGE_ID}} = this.authData?.routes?.register;
                const response = await axios.post(path, {
                    api: 'y',
                    action,
                    LANGUAGE_ID: LANGUAGE_ID
                });
                this.$store.commit('personal/updateData', {name: 'regInputs', data: response.data.regInputs});
            },
        },

        mounted() {
            this.getRegData();
        },
        beforeDestroy() {
            this.clearState();
        }
    }
</script>

<style lang="scss">
    .enter-cabinet {
        font-family: Roboto, sans-serif;
        text-transform: uppercase;
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100vh;
        overflow-y: auto;
        @include point-md {
            height: 100%;
        }

        &__auth-errors {
            color: red;
        }


        &__choose {
            width: 100%;
            display: flex;
            justify-content: space-around;
            margin-bottom: 24px;

            span {
                width: 50%;
                display: block;
                text-align: center;
                padding-bottom: 8px;

                font-size: rem(16);
                font-weight: 500;
                color: #85898B;
                cursor: pointer;
                transition: .2s linear border-color;
                border-bottom: 2px solid transparent;

                @include point-lg {
                    font-size: rem(18);
                }

                &.active {
                    color: rgba(0,0,0,0.7);
                    border-color: #eadec2;
                }
            }

        }

        &__tab {
            width: 100%;
        }

        &__forgot-password {
            display: inline;
            height: auto;
            color: #504949;
            //font-family: $font-sf;
            font-size: rem(14);
            @include point-md {
                font-size: rem(12);
            }
            @include point-lg {
                font-size: rem(14);
                margin-bottom: 20px;
            }
        }

        .def-button {
            margin-bottom: 17px;
            font-size: rem(14);
            text-transform: uppercase;
            @include point-lg {
            }
        }

        .def-input {
            font-size: rem(14);
            @include point-md {
                font-size: rem(12);
            }
            @include point-lg {
                font-size: rem(14);
            }
        }
        .def-phone, .def-email{
            margin-bottom: 20px;
        }

        .def-button-border {
            width: 100%;
        }

        .hide-btn {
            background-color: lightgray;
            pointer-events: none;
            border: 2px solid transparent;
        }

        .register_error {
            color: red;
        }

        &__registration {
            width: 100%;
        }
        input{
            width: 100%;
            margin-bottom: 8px;
        }
    }
</style>